function qualityId2Array(signID) {
let signArrayId;
    switch (signID) {
        case "1":
            signArrayId="0";
          return signArrayId;
        //   break;
  
        case "2":
            signArrayId="1";
          return signArrayId;
        //   break;
  
        case "3":
            signArrayId="2";
          return signArrayId;
          //   break;

        case "4":
            signArrayId="0";
          return signArrayId;

          case "5":
            signArrayId="1";
          return signArrayId;
        //   break;
  
        case "6":
            signArrayId="2";
          return signArrayId;
          //   break;      

          case "7":
            signArrayId="0";
          return signArrayId;
        //   break;
  
        case "8":
            signArrayId="1";
          return signArrayId;
        //   break;
  
        case "9":
            signArrayId="2";
          return signArrayId;
          //   break;

        case "10":
            signArrayId="0";
          return signArrayId;

          case "11":
            signArrayId="1";
          return signArrayId;
        //   break;
  
        case "12":
            signArrayId="2";
          return signArrayId;
          //   break;   

        }
  }


  function elementId2Array(signID) {
    let signArrayId;
        switch (signID) {
            case "1":
                signArrayId="0";
              return signArrayId;
            //   break;
      
            case "2":  
                signArrayId="1";
              return signArrayId;
            //   break;
      
            case "3":
                signArrayId="2";
              return signArrayId;
            //   break;

            case "4":   
                signArrayId="3";
              return signArrayId;
            //   break;
            case "5":
                signArrayId="0";
              return signArrayId;
            //   break;
      
            case "6":  
                signArrayId="1";
              return signArrayId;
            //   break;
      
            case "7":
                signArrayId="2";
              return signArrayId;
            //   break;

            case "8":   
                signArrayId="3";
              return signArrayId;
            //   break;
            case "9":
                signArrayId="0";
              return signArrayId;
            //   break;
      
            case "10":  
                signArrayId="1";
              return signArrayId;
            //   break;
      
            case "11":
                signArrayId="2";
              return signArrayId;
            //   break;

            case "12":   
                signArrayId="3";
              return signArrayId;
            //   break; 
        }
      }

  export { qualityId2Array, elementId2Array };


